import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconAlert = () => (_jsx("svg", { className: "oc-icon", viewBox: "0 0 2 10", children: _jsxs("g", { fill: "", children: [_jsx("path", { d: "M0 1h2v6h-2z" }), _jsx("path", { d: "M0 8h2v2h-2z" })] }) }));
export default IconAlert;
